import React from "react";
import { StopOutlined } from '@ant-design/icons';
import { Tooltip } from '@servahealth/serva-ui-kit';

interface StopOutlinedIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  tooltipText?: string;
}

const StopOutlinedIcon: React.FC<StopOutlinedIconProps> = ({
  onClick,
  className,
  style,
  tooltipText,
}) => {
  return (
    <Tooltip title={tooltipText}>
      <StopOutlined onClick={onClick} className={className} style={style} />
    </Tooltip>
  );
};

export default StopOutlinedIcon;
